import axios from 'axios';
import axiosUrl from './axios.service';
import authHeader from '../helpers/auth-header';
import store from '../store/index';
import AuthService from '../services/auth.service';
import router from '../router';
import moment from 'moment';
const API_URL = axiosUrl.getAxiosUrl();

class RecordsService {
    loadRecords(fileId, page, pageSize) {
        this.getFileName(fileId);
        this.getFileRecords(fileId, page, pageSize);
        this.getFileDoubleRecords(fileId, page, pageSize);
        store.commit('fileRecords/toggleFileRecordsLoading', false);
    }

    getFileName(fileId) {
        return axios
            .get(API_URL + `/FilesOverview/getFileName?fileId=${fileId}`, {
                headers: authHeader(),
            })
            .then((response) => {
                var fileName = response.data.name;
                store.commit('fileRecords/setFileName', fileName);
            })
            .catch((error) => {
                if (error.response.status === 401 || error.response.status === 403) {
                    // auto logout if 401 or 403 response returned from api
                    AuthService.logout();
                    router.go();
                }
            });
    }

    getFileRecords(fileId, page, pageSize) {
        return axios
            .get(API_URL + `/FileRecords/getFileRecords?fileId=${fileId}&page=${page}&pageSize=${pageSize}`, {
                headers: authHeader(),
            })
            .then((response) => {
                var fileRecords = response.data.records.result;
                store.commit('fileRecords/setTableRows', fileRecords);
            })
            .catch((error) => {
                if (error.response.status === 401 || error.response.status === 403) {
                    // auto logout if 401 or 403 response returned from api
                    AuthService.logout();
                    router.go();
                }
            });
    }

    getFileDoubleRecords(fileId, page, pageSize) {
        return axios
            .get(API_URL + `/FileRecords/getFileDoubleRecords?fileId=${fileId}&page=${page}&pageSize=${pageSize}`, {
                headers: authHeader(),
            })
            .then((response) => {
                var fileDoubleRecords = response.data.doubleRecords;
                store.commit('fileRecords/setTableDoubleRows', fileDoubleRecords);
            })
            .catch((error) => {
                if (error.response.status === 401 || error.response.status === 403) {
                    // auto logout if 401 or 403 response returned from api
                    AuthService.logout();
                    router.go();
                }
            });
    }

    filterRecords(fileId, dateFrom, dateTo, organisations, subjects, customers, scopes) {
        
        return axios
            .post(API_URL + `/FileRecords/getFileFilteredRecords`, {
                dateFrom: moment(dateFrom, "DD-MM-YYYY"),
                dateTo: moment(dateTo, "DD-MM-YYYY"),
                organisations: organisations != null ? organisations.map(d => { return d.id }) : [],
                applicationSubjects: subjects != null ? subjects.map(d => { return d.id }) : [],
                customers: customers != null ? customers.map(d => { return d.id }) : [],
                scopes: scopes != null ? scopes.map(d => { return d.id }) : [],
                years: [],
                fileId: fileId
              },
              {
                headers: authHeader()
              })
            .then((response) => {
                var fileRecords = response.data;
                store.commit('fileRecords/setTableRows', fileRecords);
            })
            .catch((error) => {
                if (error.response.status === 401 || error.response.status === 403) {
                    // auto logout if 401 or 403 response returned from api
                    AuthService.logout();
                    router.go();
                }
            });
    }

    addRecords(fileId, recordIds) {
        const recordIdsString = recordIds.join(',')
        return axios
            .get(API_URL + `/FileRecords/addFileRecords`, {
                headers: authHeader(),
                params: {
                    fileId: fileId,
                    recordIds: recordIdsString
                }
            })
            .then(() => {
                this.getFileRecords(fileId);
                this.getFileDoubleRecords(fileId);
            })
            .catch((error) => {
                if (error.response.status === 401 || error.response.status === 403) {
                    // auto logout if 401 or 403 response returned from api
                    AuthService.logout();
                    router.go();
                }
            });
    }

    rejectRecords(fileId, recordIds) {
        const recordIdsString = recordIds.join(',')    
        return axios
            .get(API_URL + `/FileRecords/rejectFileRecords`, {
                headers: authHeader(),
                params: {
                    fileId: fileId,
                    recordIds: recordIdsString
                }
            })
            .then(() => {                
                this.getFileRecords(fileId);
                this.getFileDoubleRecords(fileId);
            })
            .catch((error) => {
                if (error.response.status === 401 || error.response.status === 403) {
                    // auto logout if 401 or 403 response returned from api
                    AuthService.logout();
                    router.go();
                }
            });
    }

    removeRecords(fileId, recordIds) {
        const recordIdsString = recordIds.join(',')    
        return axios
            .get(API_URL + `/FileRecords/removeFileRecords`, {
                headers: authHeader(),
                params: {
                    fileId: fileId,
                    recordIds: recordIdsString
                }
            })
            .then(() => {                
                this.getFileRecords(fileId);
            })
            .catch((error) => {
                if (error.response.status === 401 || error.response.status === 403) {
                    // auto logout if 401 or 403 response returned from api
                    AuthService.logout();
                    router.go();
                }
            });
    }

    async updateRecord(record) {
        return axios
            .post(API_URL + '/FileRecords/updateFileRecord', 
            {
                id: record.id,
                organisation: record.organisation,
                applicationNumber: record.applicationNumber,
                applicationSubject: record.applicationSubject,
                applicationDescription: record.applicationDescription,
                programTarget: record.programTarget
            },
            {
                headers: authHeader(),
            })
            .catch((error) => {
                if (error.response.status === 401 || error.response.status === 403) {
                    // auto logout if 401 or 403 response returned from api
                    AuthService.logout();
                    router.go();
                }
                
                if (error) {
                    store.commit('fileRecords/updateModalError', error.response.data),
                    store.commit('fileRecords/enableModalError');
                }
            });
    }
}

export default new RecordsService();